import { Typography } from '@mui/material';
import { useTranslation } from 'next-i18next';

import { CertIcon, CertCourseBoxDesktop } from './style';

import theme from 'src/theme';

const CourseCardCertificateRibbon = () => {
  const { t } = useTranslation('common');

  return (
    <CertCourseBoxDesktop>
      <Typography className="text-cert" variant="body2_deprecated" component="div" color={theme.palette.commonText?.primary}>
        {t('home.course_card_certificate')}
      </Typography>
      <CertIcon className="text-cert" src="/static/icons/cert-white.svg" alt="cert" />
    </CertCourseBoxDesktop>
  );
};

export default CourseCardCertificateRibbon;
